export default __webpack_public_path__ + "static/icon-11-4-b70b096b44e5d681099d199c91095942.png";